import { IvideonHistoryActsResponseIProps } from "~/entity/Ivideon/model/schema";
import { dateFormat } from "~/shared/lib/DateFormat/dateFormat";

export interface fromServerIProps {
  data: IvideonHistoryActsResponseIProps;
  t: (props: string) => string;
  dealerName: string;
}

export const fromServer = ({ data, t }: fromServerIProps) => {
  let formatData = data?.data.map((item: any) => {
    return {
      id: item.id,
      dateTime: dateFormat(item.createdAt, { type: "datetime" }),
      typeEvent: t(`ivideonCameras.actsEvent.${item.action}`),
      user: item?.userName || "",
      comment: item.comment,
      fileName: item?.fileName || "",
    };
  });
  return formatData;
};
